import axios from "axios";
import { BASE_URL_API } from "constants/constants";
import { checkTokenExpiration } from "contexts/TokenCheck";

//Generate token
export async function generateTokenAPI(data) {
  const token = await checkTokenExpiration();
  return axios.get(BASE_URL_API + "token-management/generate", {
    headers: {
      Authorization: token,
    },
  });
}

//Get domain
export async function getDomainsAPI(data) {
  const token = await checkTokenExpiration();
  return axios.get(BASE_URL_API + "token-management/get-domains", {
    headers: {
      Authorization: token,
    },
  });
}

//Create token
export async function createTokenAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(BASE_URL_API + "token-management/create-config", data, {
    headers: {
      Authorization: token,
    },
  });
}

//Get domain
export async function getListTokenAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(BASE_URL_API + "token-management/get-configs", data, {
    headers: {
      Authorization: token,
    },
  });
}

//Update token
export async function updateTokenAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(BASE_URL_API + "token-management/update-config", data, {
    headers: {
      Authorization: token,
    },
  });
}

//Delete token
export async function deleteTokenAPI(data) {
  const token = await checkTokenExpiration();
  return axios.delete(
    BASE_URL_API + `token-management/delete-config/${data.config_id}`,
    {
      headers: {
        Authorization: token,
      },
      data,
    }
  );
}
